import { showToast } from "./Toaster";

export const showError = (error) => {
    console.error("Error While processing request:", error);
    var title = "Error";
    var message = "Something went wrong";
    if(error.response && error.response.data) {
        title = error.response.data.title;
        message = error.response.data.message
    }
    showToast(title, message, "error",20000);
}